var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading && _vm.totalData > 0)?_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n  Mostrando "+_vm._s(_vm.fromData)+" al "+_vm._s(_vm.toData)+" de "+_vm._s(_vm.totalData)+" registros.\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }